/**
 * Apply a theme dictionary as CSS custom properties on a container element.
 *
 * Keys use underscores (matching backend field names, e.g. `primary`) and are
 * converted to hyphenated CSS variables (e.g. `--primary`).
 *
 * Legacy keys are mapped to the consolidated tokens documented in `index.css`
 * so older configs keep working:
 *   text, text_primary        → --foreground
 *   text_muted, secondary_foreground_muted → --muted-foreground
 *   text_light                → --foreground-secondary
 * Canonical API keys use snake_case matching the admin theme (e.g. foreground_secondary).
 */
const THEME_KEY_ALIASES: Record<string, string> = {
  text: "foreground",
  "text-primary": "foreground",
  "text-muted": "muted-foreground",
  "text-light": "foreground-secondary",
  "secondary-foreground-muted": "muted-foreground",
};

function themeKeyToCssVarName(key: string): string {
  const hyphenated = key.replace(/_/g, "-");
  return `--${THEME_KEY_ALIASES[hyphenated] ?? hyphenated}`;
}

export function applyTheme(
  container: HTMLElement,
  theme: Record<string, string>
): void {
  for (const [key, value] of Object.entries(theme)) {
    container.style.setProperty(themeKeyToCssVarName(key), value);
  }
}
